// This file gets environment variables with guards in case they are not set

const getProcessEnv = key => {
  try {
    return process.env[key];
  } catch (_unused) {
    // continue
  }
  return undefined;
};
const getNodeEnv = () => {
  try {
    if (process.env.NODE_ENV) {
      if (['development', 'test', 'production'].includes(process.env.NODE_ENV)) {
        return process.env.NODE_ENV;
      } else {
        console.error('NODE_ENV is set to an unrecognized value.');
      }
    }
  } catch (_unused2) {
    // continue
  }

  // For non-appshell projects
  try {
    if (window.location.hostname.indexOf('.autodesk.') >= 0) {
      return 'production';
    }
  } catch (_unused3) {
    // continue
  }
  return undefined;
};
const REACT_APP_SEGMENT_API_KEY = getProcessEnv('REACT_APP_SEGMENT_API_KEY');
const REACT_APP_DISABLE_SEGMENT = getProcessEnv('REACT_APP_DISABLE_SEGMENT');
const NODE_ENV = getNodeEnv();
export { REACT_APP_SEGMENT_API_KEY, REACT_APP_DISABLE_SEGMENT, NODE_ENV };
//# sourceMappingURL=env.js.map